<template>
  <div>
    <content-frame
          :frame-src="frameSrc"
          :change="true"
    />
    <v-text-field v-if="frameSrcId"
              v-model="frameSrc"
              label="Ссылка на карту (iframe, например Яндекс.Карты)"
              outlined
    />
    <v-btn @click="saveChanges">Сохранить изменения</v-btn>
  </div>
</template>

<script>
import ContentFrame from "@/components/ui/ContentFrame.vue";
export default {
  name: "ChangeContentFrame",
  components: { ContentFrame },
  data () {
    let content_to_change = this.$store.getters['contentChanges/content_to_change']
    return {
      'frameSrc': content_to_change['frameSrc']['value_rus']
    }
  },
  computed: {
    lang() {
      return this.$i18n.locale
    },
    frameSrcId() {
      return this.$store.getters['contentChanges/content_to_change']['frameSrc']['id_content']
    }
  },
  methods: {
    /** Ссылку со страницы карт (constructorLink) преобразуем в URL виджета для iframe */
    yandexMapUrlToEmbed (url) {
      if (!url || typeof url !== 'string') return url
      const u = String(url).trim()
      if (u.includes('yandex.ru/maps/?') && u.includes('um=constructor')) {
        return u
          .replace(/yandex\.ru\/maps\/\?/, 'yandex.ru/map-widget/v1/?')
          .replace(/source=constructorLink/i, 'source=constructor')
      }
      return u
    },
    saveChanges () {
      if (!this.frameSrcId) return
      const raw = (this.frameSrc === undefined || this.frameSrc === null) ? '' : String(this.frameSrc).trim()
      const url = this.yandexMapUrlToEmbed(raw) || raw
      this.$store.dispatch('contentChanges/SAVE_CONTENT_CHANGES', {
        valueList: [{
          id_content: this.frameSrcId,
          value_rus: url,
          value_eng: url
        }]
      })
    }
  }
}
</script>

<style scoped>

</style>